<template>
  <div id="atype-pie">
    <div class="flex mar-b-30"
         style="justify-content: space-between;">
      <div class="flex"
           style="width:100%">
        <ipub-row :gutter="20">
          <ipub-col :span="3">
            <div class="flex">
              <span class="line-h-40 ipub-p2 fw-bd">Journal</span>
              <ipub-select v-model="params.journalId"
                           placeholder="Select Journal"
                           class="mar-l-12"
                           @change="getVolumeCode"
                           :options="journalList" />
            </div>
          </ipub-col>
          <ipub-col :span="6">
            <div class="flex">
              <span class="line-h-40 ipub-p2 fw-bd"
                    style="min-width:110px">Volume & Issue</span>
              <ipub-select class="mar-l-8"
                           placeholder="Select Volume"
                           v-model="params.volumeId"
                           optionTitle="code"
                           @change="getIssueCode"
                           :options="volumeList" />
              <ipub-select class="mar-l-10"
                           placeholder="Select Issue"
                           optionTitle="code"
                           :disabled="!params.volumeId"
                           @change="getData"
                           v-model="params.issueId"
                           :options="issueList" />
            </div>
          </ipub-col>
          <ipub-col :span="3">
            <div class="flex">
              <span class="line-h-40 nowrap ipub-p2 fw-bd">Status</span>
              <ipub-select v-model="params.status"
                           @change="getData"
                           class="mar-l-12"
                           :clear="true"
                           placeholder="Select Article Status">
                <template v-for="(value, key) in Status">
                  <ipub-select-option :key="key"
                                      :value="key">
                    {{ value }}
                  </ipub-select-option>
                </template>
              </ipub-select>
            </div>
          </ipub-col>
        </ipub-row>
      </div>
      <div class="flex mar-l-40">
        <div v-show="user.codeList&&user.codeList.includes('STATISTICS.GRAPHICAL_ANALYSIS.ARTICLE_TYPE.EXPORT_JOURNAL_DATA')">
          <div class="ipub-p1">
            <ipub-button type="primary"
                         style="width: 183px;"
                         @click="exp('journal')">
              Export Journal Data
            </ipub-button>
          </div>
        </div>
        <div v-show="user.codeList&&user.codeList.includes('STATISTICS.GRAPHICAL_ANALYSIS.ARTICLE_TYPE.EXPORT_PUBLISHER_DATA')"
             class="mar-l-12">
          <div class="ipub-p1">
            <ipub-button type="primary"
                         style="width: 183px;"
                         @click="exp">
              Export Publisher Data
            </ipub-button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex">
      <div style="width:330px;align-items: center;"
           class="flex">
        <div id="atype-pie-chart"
             style="width:300px;height:300px">
        </div>
      </div>
      <div style="justify-content: space-between"
           class="mar-l-20 flex">
        <div class="type-item ">
          <div class="ipub-p1 mar-b-20">Encourage for Publication ({{encourageArticalTotal}})</div>
          <div class="flex mar-b-10 ipub-p2 type-item-item"
               v-for="(item,index) in encourageArtical"
               :key="'type'+index">
            <span class="flex ipub-p2"
                  style="align-items: center;">
              <span class="item-radio"
                    :style="{background:colorType[index]}"></span>
              {{manuscriptType[item.code]}} | {{((item.num===0 || total===0)?0:item.num/total *100).toFixed(2)}}%
            </span>
            <span class="mar-l-20">{{item.num}}</span>
          </div>
        </div>

        <div class="type-item"
             style="margin-left:90px">
          <div class="ipub-p1 mar-b-20">Support for Publication ({{supportArticalTotal}})</div>
          <div class="flex mar-b-10 ipub-p2 type-item-item"
               v-for="(item,index) in supportArtical"
               :key="'type'+index">
            <span class="flex ipub-p2"
                  style="align-items: center;">
              <span class="item-radio"
                    :style="{background:colorType[index]}"></span>
              {{manuscriptType[item.code]}} | {{((item.num===0 || total===0)?0:item.num/total *100).toFixed(2)}}%
            </span>
            <span class="mar-l-20">{{item.num}}</span>
          </div>
        </div>

        <div class="type-item mar-l-100"
             style="margin-left:90px">
          <div class="ipub-p1 mar-b-20">Not Recommendation for Publication ({{notRecommendArticalTotal}})</div>
          <div class="flex mar-b-10 ipub-p2 type-item-item"
               v-for="(item,index) in notRecommendArtical"
               :key="'type'+index">
            <span class="flex ipub-p2"
                  style="align-items: center;">
              <span class="item-radio"
                    :style="{background:colorType[index]}"></span>
              {{manuscriptType[item.code]}} | {{((item.num===0 || total===0)?0:item.num/total *100).toFixed(2)}}%
            </span>
            <span class="mar-l-20">{{item.num}}</span>
          </div>
        </div>
        <!-- -->
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { statisticJournalAtype, statisticPublisherAtype } from '@/api/statistic'
import journal from '@/api/journal'
import { volume } from '@/api/vissue'
import help from '@/utils/help'

export default {
  props: {

  },
  data () {
    return {
      params: {
        journalId: '',
        volumeId: '',
        issueId: '',
        status: ''
      },
      journalList: [],
      volumeList: [],
      issueList: [],
      Status: {
        '': 'All',
        PUBLISHED: 'Online',
        UNPUBLISHED: 'Pending Online',
        RETRACTION: 'retraction'
      },
      articalType: [],
      colorType: ['#1F299C', '#16215B', '#0373FF', '#02457A', '#30D1FF', '#018ABE', '#97CADB', '#787CA9', '#A3A9F5', '#D6E8EE', '#E0EAF8', '#4c516d', '#7285A5', '#4682B4', '#588BAE', '#B0DFE5', '#008D81', '#4F97A3', '#81D8D0', '#7EF9FF', '#3FE0D0'],
      total: 0,
      encourageArtical: [],
      supportArtical: [],
      notRecommendArtical: [],
      encourageArticalTotal: 0,
      supportArticalTotal: 0,
      notRecommendArticalTotal: 0,
    }
  },
  computed: {
    ...mapGetters({
      manuscriptType: 'getManuscriptType',
      user: 'getUser'
    })
  },
  async mounted () {
    await this.getJournalList()
  },
  methods: {
    async getJournalList () {
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      if (!this.params.journalId) {
        return
      }
      this.getVolumeCode(this.params.journalId)
    },
    async getVolumeCode (journalId) {
      this.volumeList = await volume.getCode({ journalId, released: true })
      this.params.volumeId = this.volumeList[0] && this.volumeList[0].id
      this.params.issueId = ''

      localStorage.setItem('journalId', journalId)
      this.getIssueCode(this.params.volumeId)
    },
    getIssueCode (val) {
      const arr = this.volumeList.find(item => {
        if (item.id === val) {
          return item
        }
      })
      this.issueList = arr.issueCodeList
      if (this.issueList && this.issueList.length > 0) {
        this.params.issueId =
          this.issueList[this.issueList.length - 1] &&
          this.issueList[this.issueList.length - 1].id
      }
      this.getData()
    },
    async exp (type) {
      if (type && type === 'journal') {
        const res = await statisticJournalAtype.export(this.params)
        help.download(res.url, res.fileName)
        return
      }
      const res = await statisticPublisherAtype.export({ status: this.params.status })
      help.download(res.url, res.fileName)
    },
    async getData () {
      const data = await statisticJournalAtype.get(this.params)
      let arr = []
      this.encourageArticalTotal = 0
      this.supportArticalTotal = 0
      this.notRecommendArticalTotal = 0
      let total = 0
      data && data.map(item => {
        arr.push({
          name: this.manuscriptType[item.code],
          value: item.num || 0,
          publishSuggestion: item.publishSuggestion
        })
        total += Number(item.num || 0)
      })
      this.encourageArtical = data.filter(item => item.publishSuggestion === 'ENCOURAGE')
      this.encourageArtical.forEach(item => this.encourageArticalTotal += Number(item.num || 0))
      this.supportArtical = data.filter(item => item.publishSuggestion === 'SUPPORT')
      this.supportArtical.forEach(item => this.supportArticalTotal += Number(item.num || 0))
      this.notRecommendArtical = data.filter(item => item.publishSuggestion === 'NOT_RECOMMENDED')
      this.notRecommendArtical.forEach(item => this.notRecommendArticalTotal += Number(item.num || 0))
      this.articalType = arr
      this.total = total
      this.optionType()
    },
    getEchart () {
      var echarts = require('echarts')
      let myChart = echarts.init(document.getElementById('atype-pie-chart'))
      myChart.setOption(this.pieOption)
    },
    optionType () {
      this.pieOption = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            let res = `<span>${params.name}</span> <span  style="margin: 6px">|</span> <span>${params.percent}%</span> <span  style="margin-left:16px">${params.value}</span>`
            return res
          },
          extraCssText: 'background: #fff; border-radius: 50;color: #1E1D40;border:none;font-size:12px'
        },
        // legend: {
        //   orient: "vertical",
        //   top: '0',
        //   left: '0',
        //   icon: 'circle',
        //   itemWidth: 20,
        //   itemHeight: 20,
        //   textStyle: {
        //     // lineHeight: 0,
        //     // fontSize: 16
        //   },
        //   formatter: function (params) {
        //     console.log(params, 'sss')
        //     let res = `<span>${params.name}</span> <span  style="margin: 6px">|</span> <span>${params.percent}%</span> <span  style="margin-left:16px">${params.value}</span>`
        //     return res
        //   },
        // },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['55%', '90%'],

            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
              emphasis: {//对应的鼠标悬浮效果
                show: true
              },
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            color: this.colorType,
            data: this.articalType
          }
        ]
      }
      this.getEchart()
    },
  }
}
</script>

<style lang="scss" scoped>
@import './main.scss';
#atype-pie {
  .type-item {
    overflow: hidden;
    &-item {
      align-items: center;
      justify-content: space-between;
      // width: 47%;
    }
    &-item:nth-child(2n) {
      margin-right: 0;
    }
  }
  .item-radio {
    min-width: 20px;
    height: 20px;
    border-radius: 50%;
    display: block;
    margin-right: 10px;
  }
}
</style>
